import { render, staticRenderFns } from "./StadiumChatRoom.vue?vue&type=template&id=14bffd20&"
import script from "./StadiumChatRoom.vue?vue&type=script&lang=js&"
export * from "./StadiumChatRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14bffd20')) {
      api.createRecord('14bffd20', component.options)
    } else {
      api.reload('14bffd20', component.options)
    }
    module.hot.accept("./StadiumChatRoom.vue?vue&type=template&id=14bffd20&", function () {
      api.rerender('14bffd20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StadiumChatRoom.vue"
export default component.exports